import { Breadcrumb as AntBreadcrumb, BreadcrumbProps } from "antd";
import styled from "styled-components";

export const Breadcrumb: typeof AntBreadcrumb = styled(
  AntBreadcrumb
)<BreadcrumbProps>``;
